import React from "react";
import { createStyles, makeStyles, Grid, Typography, Divider } from "@material-ui/core";
import ReactApexChart from "react-apexcharts";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: "grid",
      margin: theme.spacing(2, 0, 0, 0),
      border: `2px solid  ${theme.palette.divider}`,
      borderRadius: "0.6rem",
      boxShadow: "0px 1px 2px rgba(50, 50, 93, 0.11), 0px 2px 3px rgba(0, 0, 0, 0.08)",
    },
    title: {
      maxHeight: 40,
      padding: "0.5rem 0px",
      margin: 0,
    },
    graphic: {
      [theme.breakpoints.up("xs")]: { width: "100%", height: 250 },
      [theme.breakpoints.up("sm")]: { width: "100%", height: 300 },
      [theme.breakpoints.up("md")]: { width: "100%", height: 350 },
      [theme.breakpoints.up("lg")]: { width: "100%", height: 350 },
      [theme.breakpoints.up("xl")]: { width: "100%", height: 400 },
      paddingTop: "1rem",
    },
  })
);

function ViewChart({ stepTypes }) {
  const categories = stepTypes?.map((item) => item.tipo_etapa) || [];
  const data = stepTypes?.map((item) => Number(item.qtd)) || [];

  function calcSizeBar() {
    // Similar to ModalSecretary
    const n = categories.length || 1;
    const percentWidth = Math.round((45 / (710 / n)) * 100);
    return `${percentWidth}%`;
  }

  const series = [
    {
      name: "Quantidade",
      data,
    },
  ];

  const options = {
    grid: {
      show: true,
      borderColor: "#CCC",
      strokeDashArray: "3,4",
      position: "back",
      xaxis: {
        lines: {
          show: true,
        },
      },
    },
    colors: ["#2E93fA"],
    chart: {
      type: "bar",
      toolbar: {
        show: true,
      },
    },
    labels: categories,
    plotOptions: {
      bar: {
        columnWidth: calcSizeBar(),
        borderRadius: 5,
        horizontal: false,
      },
    },
    xaxis: {
      type: "category",
      categories,
      labels: {
        show: true,
        rotate: -25,
        trim: true,
        minHeight: 0,
        maxHeight: 60,
        style: {
          fontSize: "10px",
        },
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
      floating: true,
      offsetY: 0,
    },
    fill: {
      opacity: 1,
    },
  };

  return <ReactApexChart options={options} series={series} type="bar" width="100%" height="100%" />;
}

export default function ModalStepTypes({ stepTypes }) {
  const classes = useStyles();
  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} className={classes.title}>
        <Typography gutterBottom variant="h6" align="center">
          Quantidade por tipo de etapa
        </Typography>
        <Divider />
      </Grid>
      <Grid item xs={12} className={classes.graphic}>
        <ViewChart stepTypes={stepTypes} />
      </Grid>
    </Grid>
  );
} 